<template lang="pug">
v-layout(row, wrap)
  v-flex.md12.Poppins
    v-card.cardPadrao
      v-card-text
        v-layout.areaScrool(row, wrap)
          div(style="width:100%;", v-if="!list.length && loading")
            v-progress-linear(:indeterminate="true")
          div.avisoBox(v-if="!list.length && !loading")
            span Você não possui nenhum repasse
          v-card.pa-2.ma-2.br-10.cardRepasse(v-for="item in list", :key="item.id")
              v-layout.pa-2(row, wrap)
                  v-flex.md8.xs9.Poppins
                    span.title.Captalize {{ item.data_referencia }}
                      v-btn(small, flat, v-if="item.status == $root.enums.STATUS.REPASSE_REALIZADO && item.comprovante" @click="openComprovante(item)" icon).ma-0
                        v-icon(color="accent") task
                    br
                    span {{$dayjs(item.data_inicio).format('DD/MM/YYYY')}} - {{$dayjs(item.data_fim).format('DD/MM/YYYY')}}
                  v-flex.md4.xs3.pa-0.ma-0.Poppins(style="display: flex; align-items: center;justify-content: right;")
                    v-chip(small,:style="{'color':getStatusRepasse(item).color,'background':getStatusRepasse(item).backgroundcolor}").font-weight-bold {{getStatusRepasse(item).label.toUpperCase()}}
              v-layout.pa-2(row, wrap)
                v-flex.md8.xs9.Poppins
                  span.subheading.font-weight-bold(style="color:#1d9a5a;") {{ item.valor | currency }}
                v-flex.md4.xs3.Poppins(style="display: flex; align-items: center;justify-content: right;")
                  span {{$dayjs(item.data_repasse).format('DD/MM/YYYY')}}

  DialogComprovante(ref="dialogComprovante")
</template>

<script>

import _ from "lodash";
import DialogComprovante from '@/pages/financeiro/fatura/DialogComprovante';

export default {
  props: { },
  components: {
    DialogComprovante
  },
  data () {
    return{
      repasse : {},
      repasses: [],
      rowPerPageConfig: [25, 50, 75, 100, { text: 'Todos', 'value': -1 }],
      loading: false,
      showComprovante : false
    }
  },
  created () {
  },
  watch: {
  },
  computed: {
    list () {
      const vm = this;
      return vm.repasses.sort((a, b) => {
        return vm.$dayjs(b.data_inicio) - vm.$dayjs(a.data_inicio);
      });
    }
  },
  methods: {
    validarDataRepasse(data_repasse) {
      if (!data_repasse) return false;

      const dataRepasse = this.$dayjs(data_repasse);
      const dataAtual = this.$dayjs();
      const diferencaDias = dataAtual.diff(dataRepasse, 'day');

      return diferencaDias <= 60;
    },
    openComprovante (item){
      if(this.validarDataRepasse(item.data_repasse)) window.open(item.comprovante, '_blank');
      else this.$refs.dialogComprovante.open(item);
    },
    refresh(estabelecimento_id){
      if(!estabelecimento_id) return;
      this.repasses = [];
      this.getRepasses(estabelecimento_id);
    },
    setRepasses(repasses){
      const vm = this;
      vm.repasses = repasses;
    },
    showError (error){
      const vm = this;
      let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os repasses. Atualize a página!';
      window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      vm.loading = false;
      console.log(error);
    },
    getStatusRepasse (repasse){
        const vm        = this;
        const enums    = vm.$root.enums;
        var colorLabel  = [];
        colorLabel['DISPONIVEL'] = {
          // backgroundcolor : "#FF950014",
          // color : "#FF9500",
          backgroundcolor: "rgba(255, 149, 0, 0.08)",
          color: "rgb(255, 149, 0)",
          label : "Disponível"
        };
        colorLabel[enums.STATUS.REPASSE_AGUARDANDO] = {
          backgroundcolor : "rgb(0,96,200,0.08)",
          color : "rgb(0,96,200)",
          label : "Agendado"
        };
        colorLabel[enums.STATUS.REPASSE_REALIZADO] = {
          backgroundcolor: "#1D9A5A14",
          color : "#0F7641",
          label : "Realizado"
        };
        colorLabel[enums.STATUS.SALDO_REMANESCENTE] = {
          backgroundcolor: "#0060C80A",
          color : "#0060C8",
          label : "Retido"
        };
        colorLabel[enums.STATUS.REPASSE_ERRO] = {
          backgroundcolor: "#DE3F310A",
          color : "#B30F00",
          label : "Erro"
        };
        return !repasse.id && repasse.status == enums.STATUS.REPASSE_AGUARDANDO ? colorLabel['DISPONIVEL'] : colorLabel[repasse.status] || {backgroundcolor:'',color: '', label: ''};
    },
    async getRepasses (estabelecimento_id) {
      const vm = this;
      try {
        vm.repasses = [];
        vm.loading = true;
        const {data : repasses} = await vm.$axios.get('/repasse',{
            params : {
              estabelecimento_id : estabelecimento_id
            }
        });
        vm.repasses = repasses;
        vm.loading = false;
      } catch (error) {
        vm.showError(error);
      }
    },
    async visualizarRepasse (repasse) {
      const vm = this;
      vm.repasse = repasse;
      vm.dialog.repasse = true;
    }
  }
}
</script>
<style scoped>
.Poppins {
    font-family: "Poppins", "Roboto", "Helvetica";
}
.Capitalize{
    text-transform: capitalize!important;
}
.br-5{
    border-radius: 5px !important;
}
.br-10{
    border-radius: 10px !important;
}
.cardPadrao{
    box-shadow:none !important;
    background-color: transparent;
    margin-bottom: 25px;
}
.cardRepasse{
  width: 100%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
}
.avisoBox{
    margin-top: 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.areaScrool{
  overflow-y: auto;
  height: 65vh;
  align-content: flex-start!important;
}

.cursor{
  cursor: pointer;
}

@media screen and (max-width: 960px) {
    .avisoBox img{
        width: 90%;
        height: auto;
        max-width: 500px;
        max-height: 500px;
    }
}
</style>
